import { journeyProduct } from "./metaData";
import { journeyEnum } from "./journeyEnum";

export const getProductEnum = ctx => {
  let product: string | null = null;

  const isNewBike = ctx?.query?.flow === "new";
  const isBikeRenewal = ctx?.query?.product === "bike";

  if (ctx?.req?.url) {
    journeyProduct.forEach(each => {
      const isValidJourney = !!ctx?.req?.url?.includes(each.url);
      if (isValidJourney && !isNewBike) {
        product = each.journey;
      }
    });
  }

  if (ctx?.req?.url?.includes("/bike-journey/") && isNewBike) {
    product = "newBike";
  }

  if (ctx?.req?.url?.includes("/renew-policy") && isBikeRenewal) {
    product = "renewBike";
  }

  if (ctx?.req?.url?.includes("/widgets")) {
    if (ctx?.req?.url?.includes("/bike")) {
      product = "freshBike";
    } else if (ctx?.req?.url?.includes("/car")) {
      product = "freshCar";
    }
  }

  return product;
};

type JourneyProductKey = keyof typeof journeyEnum;

/**
 * Derives the segment journey display string from a URL path (and optional query).
 * Mirrors getProductEnum logic for client-side use (e.g. when window.product is not set).
 * @param pathname - e.g. asPath without query/hash, or window.location.pathname
 * @param query - optional { flow?: string; product?: string } for flow=new, product=bike
 * @returns journey string e.g. "buy new car", or undefined if not determinable
 */
export const getJourneyFromPath = (
  pathname: string,
  query?: { flow?: string; product?: string }
): string | undefined => {
  if (!pathname) return undefined;

  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const isNewBike = query?.flow === "new";
  const isBikeRenewal = query?.product === "bike";

  if (path.includes("/bike-journey/") && isNewBike) {
    return journeyEnum.newBike;
  }
  if (path.includes("/renew-policy") && isBikeRenewal) {
    return journeyEnum.renewBike;
  }
  if (path.includes("/widgets/")) {
    if (path.includes("/bike")) return journeyEnum.freshBike;
    if (path.includes("/car")) return journeyEnum.freshCar;
  }

  for (const each of journeyProduct) {
    if (path.includes(each.url) && !isNewBike) {
      return journeyEnum[each.journey as JourneyProductKey];
    }
  }

  return undefined;
};
